import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getAuthHeader = () => {
  const token = localStorage.getItem('access_token') || localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

export const STAGES = [
  { value: 'new', label: 'New Lead', color: 'bg-blue-500' },
  { value: 'contacted', label: 'Contacted', color: 'bg-purple-500' },
  { value: 'interested', label: 'Interested', color: 'bg-yellow-500' },
  { value: 'test_drive', label: 'Test Drive', color: 'bg-teal-500' },
  { value: 'negotiation', label: 'Negotiation', color: 'bg-pink-500' },
  { value: 'finance_pending', label: 'Finance Approval', color: 'bg-orange-500' },
  { value: 'dp_pending', label: 'DP Pending', color: 'bg-amber-500' },
  { value: 'won', label: 'Won', color: 'bg-green-500' },
  { value: 'lost', label: 'Lost', color: 'bg-red-500' }
];

export const LEAD_SOURCES = [
  'Walk-in', 'Phone Enquiry', 'Website', 'Digital Marketing',
  'Referral', 'Exhibition', 'Campaign Activity', 'Exchange Mela',
  'Incoming Calls', 'Outdoor Advertising', 'TV Advertising',
  'Paper Advertising', 'Radio Advertising', 'Online Portal', 'Other'
];

export const formatDateDDMMYYYY = (dateStr) => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  } catch { return dateStr; }
};

export const getAvatarColor = (name) => {
  const colors = [
    'bg-blue-500', 'bg-green-500', 'bg-purple-500', 'bg-pink-500',
    'bg-indigo-500', 'bg-teal-500', 'bg-orange-500', 'bg-cyan-500'
  ];
  const index = name ? name.charCodeAt(0) % colors.length : 0;
  return colors[index];
};
